// extracted by mini-css-extract-plugin
module.exports = {"createButton":"CreateTemplate_createButton__RtZ9J"};